import React, { useState, useEffect, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { ACTION_SHOW_LOADING, saveCoverCategories } from '../../../Actions/Page';
import { fetchAllCategoriesName } from '../../../Actions/Ebook';
import { Col, Row } from 'antd';
import Helmet from 'react-helmet';
import { useColor } from 'color-thief-react';
import { isMobile } from 'react-device-detect';

import ReactGA from 'react-ga';

ReactGA.pageview(window.location.pathname + window.location.search);

const CategoryAll = props => {
   const [data, setData] = useState([]);
   const [coverArr, setCoverArr] = useState([]);
   const [cateLength, setCateLength] = useState(null);
   const imgRef = useRef(null);
   const [widthImage, setWidthImage] = useState(235);
   const [colorObj, setColorObj] = useState([]);

   useEffect(() => {
      props.dispatch(ACTION_SHOW_LOADING(true));
      const fetchData = async () => {
         let res = await fetchAllCategoriesName();
         if (res.status) {
            setData(res.data.categories);
            if (res.data && Array.isArray(res.data.categories)) {
               setCateLength(res.data.categories.length);
               if (res.data.categories.length !== props.Page.coverArr.length) {
                  res.data.categories.map(async e => {
                     setCoverArr(oldState => [
                        ...oldState,
                        {
                           catId: e.catId,
                           data: {
                              coverImage: e.coverImage,
                              coverImageWebp: e.coverImageWebp,
                           },
                        },
                     ]);
                  });
               }
            }
            props.dispatch(ACTION_SHOW_LOADING(false));
         }
      };
      fetchData();
   }, []);
   useEffect(() => {
      if (cateLength === coverArr.length) {
         props.dispatch(saveCoverCategories(coverArr));
      }
   }, [coverArr]);

   useEffect(() => {
      if (data.length === colorObj.length) {
         setData(oldState => {
            return oldState.map(e => {
               let bgEle = colorObj.filter(el => el.catId === e.catId)[0];
               let bg =
                  bgEle.color.value &&
                  bgEle.color.value[0] > 230 &&
                  bgEle.color.value[1] > 230 &&
                  bgEle.color.value[2] > 230
                     ? 'rgb(230, 230, 230)'
                     : bgEle.color.hex;
               return Object.assign({}, e, {
                  bg: bg, //bgEle.color.isDark bgEle.color.isLight
                  fontColor: bgEle.color === 'error' || bgEle.color.isLight ? '#000000' : '#ffffff',
               });
            });
         });
      }
   }, [colorObj]);

   const CategoryCard = props => {
      const { cat, index } = props;
      const colorData = useColor(props.cat.coverImage, 'hex', {
         crossOrigin: 'anonymous',
      });
      const [fontColor, setFontColor] = useState('#000000');

      useEffect(() => {
         if (colorData.data) checkColorIsLight();
      }, [colorData.data]);

      const checkColorIsLight = () => {
         let color = colorData.data;
         color = color.replace('#', '');
         const r = parseInt(color.substring(0, 2), 16);
         const g = parseInt(color.substring(2, 4), 16);
         const b = parseInt(color.substring(4, 6), 16);
         const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

         if (luminance < 128) {
            setFontColor('#ffffff ');
         } else {
            setFontColor('#000000');
         }
      };

      return (
         // <div>{colorData.data}</div>
         <Link key={cat.catId} to={`${props.match.url}/${cat.catId}`}>
            <button
               className="gradient"
               style={{
                  height: `${widthImage}px`,
                  backgroundColor: colorData.data,
                  display: 'grid',
               }}
            >
               <p
                  style={
                     isMobile
                        ? {
                             color: fontColor,
                             transform: 'translateY(-16px)',
                          }
                        : { color: fontColor }
                  }
               >
                  {cat.catName}
               </p>
               <img
                  alt=""
                  src={cat.coverImage + ''}
                  style={{
                     width: `${widthImage / 2.5}px`,
                     margin: '0 auto',
                     boxShadow: ' rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                  }}
                  onError={e => {
                     e.currentTarget.onerror = null;
                     e.currentTarget.src =
                        'data:image/png;base64,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';
                  }}
               />
            </button>
         </Link>
      );
   };

   const listMemo = useMemo(() => {
      return (
         <div
            className="category-all"
            style={props.Page.screensize.width > 1000 ? { width: '1000px' } : { width: '100%' }}
         >
            <Helmet>
               <title>{`Hytexts: หมวดหมู่`}</title>
            </Helmet>
            {props.Page.screensize.width > 900 ? <h1>หมวดหมู่</h1> : ''}
            <Row gutter={[20, { xs: 10, sm: 20 }]} justify="center" type="flex">
               {
                  data.map((cat, index) => {
                     return (
                        <Col xs={12} sm={8} md={6} key={cat.catId}>
                           <CategoryCard cat={cat} index={index} match={props.match} />
                           {/* <Link key={cat.catId} to={`${props.match.url}/${cat.catId}`}>
           
                    <button
                      className="gradient"
                      ref={imgRef}
                      style={{
                        height: `${widthImage}px`,
                        backgroundColor: cat.bg,
                        display: "grid",
                      }}
                    >
                      <p
                        style={
                          isMobile
                            ? {
                                color: cat.fontColor,
                                transform: "translateY(-16px)",
                              }
                            : { color: cat.fontColor }
                        }
                      >
                        {cat.catName}
                      </p>
                      <img
                        alt=""
                        id={cat.catId}
                        // src={
                        //   cat.coverImage
                        //     ? props.Page.OSName.match(/(iOS|Mac OS)/i)
                        //       ? cat.coverImage
                        //       : props.Page.browserName.match(/(Safari|Firefox)/i)
                        //       ? cat.coverImage
                        //       : cat.coverImageWebp
                        //     : ""
                        // }
                        style={{
                          width: `${widthImage / 2.5}px`,
                          margin: "0 auto",
                        }}
                        onLoad={() => {
                          if (imgRef.current) {
                            if (index === data.length - 1) {
                              setWidthImage(imgRef.current.clientWidth);
                            }
                          }
                        }}
                      />
                    </button>
                  </Link> */}
                        </Col>
                     );
                  })
                  // data.length % 4 === 5 ? (
                  //   <Col xs={12} sm={8} md={18}></Col>
                  // ) : data.length % 4 === 4 ? (
                  //   <Col xs={0} sm={16} md={12}></Col>
                  // ) : data.length % 4 === 3 ? (
                  //   <Col xs={12} sm={8} md={6}></Col>
                  // ) : data.length % 4 === 2 ? (
                  //   <Col xs={0} sm={16} md={12}></Col>
                  // ) : data.length % 4 === 1 ? (
                  //   <Col xs={12} sm={16} md={18}></Col>
                  // ) : (
                  //   ""
                  // ),
               }
            </Row>
         </div>
      );
   }, [data.length]);

   return listMemo;
};

const mapStateToProps = state => {
   return {
      Page: state.Page,
      authentication: state.Authentication,
   };
};

export default withRouter(connect(mapStateToProps)(CategoryAll));
